module.exports = __webpack_public_path__ + "img/leave-distribution.fb2a431c.png";